import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { m } from "framer-motion";
import { Helmet } from "react-helmet-async";
import { useConversion } from "../contexts/ConversionContext";

const Dakujeme = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isValidConversion, getStoredConversion, clearConversion } =
    useConversion();
  const [hasTracked, setHasTracked] = useState(false);

  useEffect(() => {
    // Scroll to top on page load
    window.scrollTo(0, 0);

    // Try to get conversion data from location state first
    let conversionData = location.state?.conversion;
    console.log("Location state conversion:", conversionData);

    // Fallback to sessionStorage if location state is not available (e.g., page refresh)
    if (!conversionData) {
      conversionData = getStoredConversion();
      console.log("SessionStorage conversion:", conversionData);
    }

    // Validate conversion data
    const isValid = isValidConversion(conversionData);
    console.log("Conversion validation result:", isValid, "Data:", conversionData);

    if (!isValid) {
      // No valid conversion found - redirect to homepage
      console.warn("Invalid or expired conversion data, redirecting to homepage");
      navigate("/", { replace: true });
      return;
    }

    // Valid conversion found - only track pageview (conversion already tracked on form submit)
    if (!hasTracked && window.dataLayer) {
      // Push virtual pageview for better tracking
      window.dataLayer.push({
        event: "virtualPageview",
        pagePath: "/dakujeme",
        pageTitle: "Thank You - Contact Form",
      });

      setHasTracked(true);
    }

    // Cleanup: Remove conversion data after tracking to prevent duplicate conversions
    clearConversion();
  }, [location, navigate, isValidConversion, getStoredConversion, clearConversion, hasTracked]);

  return (
    <>
      <Helmet>
        <title>Ďakujeme za váš záujem | INAQ</title>
        <meta
          name="description"
          content="Ďakujeme za váš záujem. Čoskoro sa vám ozveme."
        />
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-pink-50 to-purple-50 px-4 pt-[80px]">
        <m.div
          className="max-w-[640px] w-full bg-white rounded-lg shadow-xl p-12 sm:p-8 text-center"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          {/* Success Icon */}
          <div className="flex justify-center mb-6">
            <img
              src="/assets/img/iq_tick.gif"
              alt="Success"
              className="w-20 h-20"
            />
          </div>

          {/* Heading */}
          <h1 className="font-[Oxanium] text-4xl sm:text-3xl text-inaqpurple font-bold mb-4">
            Ďakujeme za váš záujem!
          </h1>

          {/* Message */}
          <p className="font-rubik text-lg sm:text-base text-gray-700 mb-8 leading-relaxed">
            Váš dopyt sme úspešne prijali. Čoskoro sa vám ozveme a prediskutujeme
            možnosti spolupráce.
          </p>

          {/* Divider */}
          <div className="border-t border-gray-200 my-8"></div>

          {/* Additional Content */}
          <div className="mb-8">
            <h2 className="font-[Oxanium] text-xl text-inaqpurple font-medium mb-4">
              Zatiaľ si môžete prečítať
            </h2>
            <p className="font-rubik text-sm text-gray-600 mb-6">
              Naše najnovšie články o B2B marketingu a stratégii
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link
              to="/blog"
              className="w-full sm:w-auto px-8 py-3 bg-inaqgold text-white font-rubik font-medium rounded-sm hover:bg-opacity-90 transition-all duration-300 text-center"
            >
              Prejsť na blog
            </Link>
            <Link
              to="/"
              className="w-full sm:w-auto px-8 py-3 border-2 border-inaqgold text-inaqgold font-rubik font-medium rounded-sm hover:bg-inaqgold hover:text-white transition-all duration-300 text-center"
            >
              Späť na homepage
            </Link>
          </div>

          {/* Footer Note */}
          <p className="font-rubik text-xs text-gray-500 mt-8">
            V prípade naliehavých otázok nás môžete kontaktovať na{" "}
            <a
              href="mailto:info@inaq.sk"
              className="text-inaqgold hover:underline"
            >
              info@inaq.sk
            </a>
          </p>
        </m.div>
      </div>
    </>
  );
};

export default Dakujeme;
